import { ContentImagesLinks } from 'module/Model/Content/item/ContentImagesLinks';
import { ContentItemType } from './item/ContentItemType';
import { Mapper } from 'module/Common';
import {
  ContentItem,
  ContentRichText,
  ContentSingleImage,
  ContentUnknown,
  ContentMultipleImages,
  ContentRichTextTwoCols,
  ContentSubTitle,
  ContentError,
  ContentEmbed,
  ContentRichTextThreeCols,
  ContentSpace,
} from './item';

export * from './item';
export { ContentItemType } from './item/ContentItemType';
export type Content = Array<ContentItem>;

export namespace Content {
  const contentMapper: Mapper<ContentItem> = Mapper.catchError(
    e => ContentError.create(e),
    (input: any, path: Array<string>): ContentItem => {
      const type = Mapper.exec(
        Mapper.mapSchemaPartial({ acf_fc_layout: Mapper.str }, v => v.acf_fc_layout),
        input,
        path
      );
      switch (type) {
        case ContentItemType.RichText:
          return Mapper.exec(ContentRichText.mapper, input, path);
        case ContentItemType.SingleImage:
          return Mapper.exec(ContentSingleImage.mapper, input, path);
        case ContentItemType.MultipleImages:
          return Mapper.exec(ContentMultipleImages.mapper, input, path);
        case ContentItemType.RichTextTwoCols:
          return Mapper.exec(ContentRichTextTwoCols.mapper, input, path);
        case ContentItemType.RichTextThreeCols:
          return Mapper.exec(ContentRichTextThreeCols.mapper, input, path);
        case ContentItemType.SubTitle:
          return Mapper.exec(ContentSubTitle.mapper, input, path);
        case ContentItemType.ImagesLinks:
          return Mapper.exec(ContentImagesLinks.mapper, input, path);
        case ContentItemType.Embed:
          return Mapper.exec(ContentEmbed.mapper, input, path);
        case ContentItemType.Space:
          return Mapper.exec(ContentSpace.mapper, input, path);
        default:
          console.warn(`Unhandled content type ${type}`);
          return Mapper.exec(ContentUnknown.mapper, input, path);
      }
    }
  );

  export const mapper = Mapper.arrayOrEmptyIfNull(contentMapper);
}



// WEBPACK FOOTER //
// ./src/module/Model/Content/index.ts